import { render, staticRenderFns } from "./audios.vue?vue&type=template&id=1d098126&scoped=true&"
import script from "./audios.vue?vue&type=script&lang=js&"
export * from "./audios.vue?vue&type=script&lang=js&"
import style0 from "./audios.vue?vue&type=style&index=0&id=1d098126&lang=scss&scoped=true&"
import style1 from "./audios.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d098126",
  null
  
)

export default component.exports